import createCache from "@emotion/cache";

export const createEmotionCache = () => {
  const nonce = document
    .querySelector('meta[name="csp-nonce"]')
    ?.getAttribute("content") ?? undefined;

  return createCache({
    key: "css",
    nonce,
  });
};
